import EntityExportHandler from 'common/entity/generic/EntityExportHandler';
import { requestPjpExport as pjpExportApi } from 'common/middleware/api';

export default class PjpExportHandler extends EntityExportHandler {
    constructor() {
        super();
        this.exportApi = pjpExportApi;
    }

    makeExportRequest(requestParams) {
        const params = { clientId: this.clientId, pjpId: this.pjpId };
        return this.exportApi
            .post(params, requestParams)
            .then(response => {
                this.processResponse(response);
            })
            .catch(err => {
                throw err;
            });
    }

    initialiseAndMakeExportRequest(
        requestParams,
        clientId,
        showToastAction,
        updateToastAction,
        hideToastAction,
        options
    ) {
        this.pjpId = options.planId;
        return super.initialiseAndMakeExportRequest(
            requestParams,
            clientId,
            showToastAction,
            updateToastAction,
            hideToastAction,
            options
        );
    }
}
